import React from 'react'
import { TabConfig } from '../../types'
import TabsMenu from './Menu'
import Pages from './Pages'

interface TabbedPageProps {
	tabs: TabConfig[]
}

export default function RoutedTabs({ tabs }: TabbedPageProps) {
	return (
		<>
			<TabsMenu tabs={tabs} />
			<Pages tabs={tabs} />
		</>
	)
}
